import styled from "@emotion/styled";
import { Alignments, FontSizes, Icons, Row, Spacings, Text, TextButton, } from "@polestar/component-warehouse-react";
import * as React from "react";
const ChangeLocationLabel = styled(Text) `
  vertical-align: center;
  margin-right: ${Spacings.xxSmall};
`;
export const ChangeLocation = ({ label, location, onChangeLocationClick, }) => {
    const changeLocationLabelVariant = {
        fontSize: {
            mobile: FontSizes.body,
        },
    };
    return (React.createElement(Row, { crossAxisAlignment: "center" },
        React.createElement(ChangeLocationLabel, { variant: changeLocationLabelVariant },
            label,
            ":"),
        React.createElement(TextButton, { "aria-label": label, onClick: () => onChangeLocationClick(), icon: Icons.arrowRight, iconPosition: Alignments.right }, location)));
};
ChangeLocation.defaultProps = {
    label: "Change Location",
};
export default ChangeLocation;
